import { loginUser, qrLoggingIn, setSession } from 'actions'
import LocalUserService from 'services/localUserService'

const userService = new LocalUserService()

export function completeMagicLinkLogin(dispatch, data) {
  if (!data?.isSuccessfull && data?.isSuccessfull !== true) {
    return false
  }

  userService.setCurrentUserInfo(data)
  userService.storeLastUser(data.user)

  dispatch(qrLoggingIn())
  dispatch(setSession(data.sessionId))
  dispatch(loginUser(data.user, data.userToken, data.userId, data.sessionId))

  return true
}

export function mapPendingLoginStatusToSocketPayload(result) {
  if (!result?.sessionId || !result?.user) {
    return null
  }

  return {
    isSuccessfull: true,
    sessionId: result.sessionId,
    merchantId: result.merchantId,
    dashboardUserId: result.dashboardUserId,
    userId: result.userId,
    userToken: result.userToken,
    user: result.user
  }
}
